import {ResourcesConfig} from 'aws-amplify';

export const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: import.meta.env.VITE_APP_USER_POOL_CLIENT_ID,
      userPoolId: import.meta.env.VITE_APP_USER_POOL_ID,
      // region: 'us-east-1',
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_APP_DOMAIN,
          scopes: ['phone', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [import.meta.env.VITE_SOCIAL_SIGNIN_URL],
          redirectSignOut: [import.meta.env.VITE_SOCIAL_SIGNOUT_URL],
          responseType: 'token',
        },
      },
      // username: 'true',
      // Default: {
      //   authenticationFlowType: "CUSTOM_AUTH"
      // },
    },
  },
};
